import Axios from "axios";
import _ from "lodash";

const baseURL = process.env.BARRAMUNDI;
const baseURLci = process.env.CI_APPS;

export default {
    getBillings(clientId, params) {
        return Axios.get(`${baseURL}actor/client/${clientId}/billing`, {
            params
        }).then(response => response.data.response);
    },
    removeCredit(params) {
        return Axios.delete(`${baseURLci}client/credit/remove`, {
            params
        }).then(response => response.data);
    },
    convertCredit(formData) {
        return Axios.post(`${baseURLci}billing/credit/convert`, formData).then(
            response => response.data
        );
    },
    refundCredit(formData) {
        return Axios.post(
            `${baseURLci}billing/credit/submit_refund_to_card`,
            formData
        ).then(response => response.data);
    },
    saveCredit(params) {
        // endpoint using CI
        let formData = new FormData();

        _.forEach(params, function (value, key) {
            formData.append(key, value);
        });

        return Axios.post(`${baseURLci}billing/credit/save`, formData).then(
            response => response.data
        );
    },
    getEstimate(estimateId) {
        return Axios.get(`${baseURL}billing/estimate/${estimateId}`).then(
            response => response.data.response
        );
    },
    removeEstimate(estimateId) {
        return Axios.delete(`${baseURLci}billing/estimate/remove`, {
            params: { id: estimateId }
        }).then(response => response.data);
    },
    approveEstimate(params) {
        let formData = new FormData();

        _.forEach(params, function (value, key) {
            formData.append(key, value);
        });

        return Axios.post(
            `${baseURLci}billing/estimate/approve`,
            formData
        ).then(response => response.data);
    },
    getEstimateSoap(estimateId) {
        return Axios.get(`${baseURL}billing/estimate-soap/${estimateId}`).then(
            response => response.data.response
        );
    },
    convertEstimate(formData) {
        return Axios.post(
            `${baseURL}billing/estimate/save-as-invoice`,
            formData
        ).then(response => response.data.response);
    },
    sendEmail(formData) {
        return Axios.post(`${baseURLci}billing/invoice/send`, formData).then(
            response => response.data
        );
    },
    printPdf(params) {
        return Axios.get(`${baseURLci}billing/invoice/pdf`, { params }).then(
            response => response.data
        );
    },
    printOnlineInvoicePdf(params) {
        return Axios.get(`${baseURLci}billing/invoice/printOnlineInvoicePdf`, {
            params
        }).then(response => response.data);
    },
    removeInvoice(invoiceId) {
        return Axios.delete(`${baseURLci}billing/invoice/remove`, {
            params: { id: invoiceId }
        }).then(response => response.data);
    },
    removeInvoiceRecord(invoiceId, flag) {
        return Axios.delete(`${baseURLci}billing/invoice/remove_record`, {
            params: { id: invoiceId, flag: flag }
        }).then(response => response.data);
    },
    getInvoicesWithBalance(clientId) {
        return Axios.get(
            `${baseURL}actor/client/${clientId}/invoice-with-balance`
        ).then(response => response.data.response);
    },
    writeOffInvoice(formData) {
        return Axios.post(`${baseURLci}billing/writeoff/save`, formData).then(
            response => response.data
        );
    },
    markPaidInvoice(formData) {
        return Axios.post(
            `${baseURLci}billing/invoice/mark_paid`,
            formData
        ).then(response => response.data);
    },
    saveRefund(formData) {
        return Axios.post(`${baseURLci}billing/refund/save`, formData).then(
            response => response.data
        );
    },
    removeWriteOff(writeOffId) {
        return Axios.delete(`${baseURLci}billing/writeoff/remove`, {
            params: { id: writeOffId }
        }).then(response => response.data);
    },
    getInvoices(clientId, excludeInvZero = false) {
        excludeInvZero = excludeInvZero ? "?exclude_inv_zero=true" : "";
        return Axios.get(
            `${baseURL}actor/client/${clientId}/invoice${excludeInvZero}`
        ).then(response => response.data.response);
    },
    waiveLateFee(formData) {
        return Axios.post(
            `${baseURLci}business/late_fee/confirm_waive`,
            formData
        ).then(response => response.data);
    },
    emailStatement(formData) {
        return Axios.post(`${baseURLci}client/statement/email`, formData).then(
            response => response.data
        );
    },
    getStatementDate(params) {
        return Axios.get(`${baseURLci}client/statement/get_date`, {
            params
        }).then(response => response.data);
    },
    getDeclinedInvoices(params) {
        return Axios.get(`${baseURL}billing/declined-invoice-item`, {
            params
        }).then(response => response.data.response);
    }
};
